import { DiariseOptionModel } from "../models/diarise-option.model";

export class DiariseOptionClickEvent {
    diariseOption: DiariseOptionModel
    constructor(_diariseOption: DiariseOptionModel)
    {
        this.diariseOption = _diariseOption;
    }
}